import React from 'react';
import styled from 'styled-components';
import InfoCard from './InfoCard'; // Reuse or adapt KPIBox
import { cores } from '../../../../styles/styleUtils';

const ChampionContainer = styled.div`
  background-color: ${cores.branco};
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 25px;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: ${cores.chumbo};
  margin: 0;
`;

const FilterButton = styled.button`
  background-color: ${cores.laranja};
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${cores.laranjaEscuro};
  }
`;

const InfoCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); // Responsive grid
  gap: 20px;
  margin-bottom: 15px; // Space before filter text
`;

const FilterText = styled.p`
  font-size: 0.8rem;
  color: ${cores.cinzaMedio};
  margin-top: 15px;
`;

const championInfo = [
  { text: 'Potência do Kit: 4,4 kWp' },
  { text: 'Fornecedor: WEG' },
  { text: 'Estrutura: Fibrocimento' },
];

function SalesChampionSection({ campeaoVendas }) {
  const handleFiltersClick = () => {
    console.log('Champion Filters clicked');
    // Logic to open filter options
  };

  return (
    <ChampionContainer>
      <SectionHeader>
        <SectionTitle>CAMPEÃO DE VENDAS</SectionTitle>
      </SectionHeader>
      <InfoCardsContainer>
        <InfoCard text={`Potência do Kit: ${campeaoVendas.potenciaCampeao || ""} kwp`} />
        <InfoCard text={`Fornecedor: ${campeaoVendas.fornecedorCampeao || ""}`} />
        <InfoCard text={`Estrutura: ${campeaoVendas.estruturaCampeao || ""}`} />
      </InfoCardsContainer>
    </ChampionContainer>
  );
}

export default SalesChampionSection;
